import WallCommon from "./wallCommon";
import {createPageToLoadArray} from "../../constants";

export default class BackWall extends WallCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'back_wall';
    this.partName = 'Back Wall';
    this.translateId = "visualizer.bathroom.walls.back_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    if (isChild) {
      createPageToLoadArray(this);
    }
  }
}
